import api from '@/lib/api'

const state = () => ({
  byPro: { labels: [], data: [] },
  byService: { labels: [], data: [] },
  byUser: { labels: [], data: [] },
  detail: [],
})

const getters = {
  byPro: state => state.byPro,
  byService: state => state.byService,
  byUser: state => state.byUser,
  detail: state => state.detail,
}

const actions = { 
  async loadByPro ({ commit }, { limit, days } = {}) {
    const method = '/dashboard/by_pro'

    let params = new URLSearchParams()
    if (limit != null) params.append( 'limit', limit )
    if (days != null) params.append( 'days', days )

    const result = await api.get(method + (params == '' ? params : '?' + params))
    if (result.ok) {
      const data = await result.json()
      commit('SET_BY_PRO', data)
      return { ok: true, data }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadByService ({ commit }, { limit, days } = {}) {
    const method = '/dashboard/by_service'

    let params = new URLSearchParams()
    if (limit != null) params.append( 'limit', limit )
    if (days != null) params.append( 'days', days )

    const result = await api.get(method + (params == '' ? params : '?' + params))
    if (result.ok) {
      const data = await result.json()
      commit('SET_BY_SERVICE', data)
      return { ok: true, data }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadByUser ({ commit }, { limit, days } = {}) {
    const method = '/dashboard/by_user'

    let params = new URLSearchParams()
    if (limit != null) params.append( 'limit', limit )
    if (days != null) params.append( 'days', days )

    const result = await api.get(method + (params == '' ? params : '?' + params))
    if (result.ok) {
      const data = await result.json()
      commit('SET_BY_USER', data)
      return { ok: true, data }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadDetail ({ commit }, { days, pro_ids=[], user_ids=[], service_ids=[] } = {}) {
    let method = '/dashboard/detail'

    let params = new URLSearchParams()
    if (days != null) params.append('days', days)
    pro_ids.forEach( id => params.append('pro_ids[]', id) )
    user_ids.forEach( id => params.append('user_ids[]', id) )
    service_ids.forEach( id => params.append('service_ids[]', id) )

    const result = await api.get(method + (params == '' ? params : '?' + params))
    
    if (result.ok) {
      const data = await result.json()
      commit('SET_DETAIL', data)
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },
}

const mutations = { 
  SET_BY_PRO: (state, data) => state.byPro = data,
  SET_BY_SERVICE: (state, data) => state.byService = data,
  SET_BY_USER: (state, data) => state.byUser = data,
  SET_DETAIL: (state, data) => state.detail = data,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}